var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customers-table round-borders" },
    [
      _c(
        "q-scroll-area",
        {
          staticClass: "full-width customers-table__scroll",
          attrs: {
            "thumb-style": {
              width: "5px",
              "background-color": "#555",
              opacity: 1
            }
          }
        },
        [
          _c(
            "q-infinite-scroll",
            {
              ref: "infiniteScroll",
              staticClass: "full-width",
              attrs: { handler: _vm.handleInfiniteScroll, offset: 300 }
            },
            [
              _vm._l(_vm.customers, function(customer) {
                return _c(
                  "div",
                  { key: customer.id },
                  [
                    _c(_vm.rows[customer.type], {
                      tag: "component",
                      attrs: { customer: customer },
                      on: { openUpdateModal: _vm.handleModalOpen }
                    })
                  ],
                  1
                )
              }),
              _c(
                "div",
                {
                  staticClass: "row justify-center",
                  attrs: { slot: "message" },
                  slot: "message"
                },
                [_c("q-spinner-dots", { attrs: { name: "dots", size: 40 } })],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }